import React from 'react';
import Icon from 'components/Icon';
import Button from 'components/Button';
import {FormattedMessage, injectIntl, defineMessages} from 'react-intl';
import ButtonUnstyled from 'components/ButtonUnstyled';

const MESSAGES = defineMessages({
  delete: {
    defaultMessage: 'Delete filter',
    id: 'FilterEditorRemove__TrashLabel',
    description: 'Label for trash can icon that deletes the filter',
  },
});

const FilterEditorApply = ({onClick}) => (
  <div className="FilterEditor__Apply">
    <Button onClick={onClick} type={Button.TYPES.SECONDARY} full={true}>
      <FormattedMessage
        id="FilterEditorApply__Apply"
        description="Button to apply a new or edited filter"
        defaultMessage="Apply"
      />
    </Button>
  </div>
);

const FilterEditorRemove = injectIntl(({onClick, intl}) => (
  <div className="FilterEditor__Remove">
    <ButtonUnstyled
      onClick={onClick}
      title={intl.formatMessage(MESSAGES.delete)}
    >
      <Icon icon={Icon.OPTIONS.TRASH} />
    </ButtonUnstyled>
  </div>
));

const FilterEditorContainer = ({
  children,
  canApply,
  onApply,
  canRemove,
  onRemove,
}) => (
  <div className="FilterEditor">
    <div className="FilterEditor__Controls">
      <div className="FilterEditor__Steps">{children}</div>
      {canRemove ? <FilterEditorRemove onClick={onRemove} /> : null}
    </div>
    {canApply ? <FilterEditorApply onClick={onApply} /> : null}
  </div>
);

export default FilterEditorContainer;
